
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Checkbox,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Radio,
  RadioGroup,
  MenuItem,
  Select,
  InputLabel
} from "@mui/material";
import { Close, RocketLaunch, Info } from "@mui/icons-material";

export default function PreviewModal({ isOpen, onClose, form, onPublish }) {

 //console.log("Previewing form:", form);
  const handleSubmit = (e) => {
    e.preventDefault();
   //console.log("Form submitted (preview mode)");
  };

  const handlePublish = async () => {
    await onPublish();
    onClose();
  };

  const renderField = (field) => {
    const isRequired = field.required;
    const fieldId = `preview-${field.id}`;

    switch (field.type) {
      case "text":
      case "email":
      case "number":
        return (
          <TextField
            key={field.id}
            id={fieldId}
            type={field.type}
            label={field.label}
            placeholder={field.placeholder}
            required={isRequired}
            fullWidth
            variant="outlined"
            margin="normal"
          />
        );

      case "textarea":
        return (
          <TextField
            key={field.id}
            id={fieldId}
            label={field.label}
            placeholder={field.placeholder}
            required={isRequired}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            margin="normal"
          />
        );

      case "select":
        return (
          <FormControl key={field.id} fullWidth margin="normal">
            <InputLabel>{field.placeholder || "Select an option"}</InputLabel>
            <Select required={isRequired} label={field.label}>
              {field.options?.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case "radio":
        return (
          <FormControl key={field.id} component="fieldset" margin="normal">
            <FormLabel component="legend">{field.label}</FormLabel>
            <RadioGroup>
              {field.options?.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={option}
                  control={<Radio required={isRequired} />}
                  label={option}
                />
              ))}
            </RadioGroup>
          </FormControl>
        );

      case "checkbox":
        if (field.options && field.options.length > 1) {
          return (
            <FormControl key={field.id} component="fieldset" margin="normal">
              <FormLabel component="legend">{field.label}</FormLabel>
              <FormGroup>
                {field.options.map((option, index) => (
                  <FormControlLabel
                    key={index}
                    control={<Checkbox />}
                    label={option}
                  />
                ))}
              </FormGroup>
            </FormControl>
          );
        } else {
          return (
            <FormControlLabel
              key={field.id}
              control={<Checkbox required={isRequired} />}
              label={field.options?.[0] || field.label}
            />
          );
        }

      case "date":
        return (
          <TextField
            key={field.id}
            id={fieldId}
            label={field.label}
            type="date"
            required={isRequired}
            fullWidth
            InputLabelProps={{ shrink: true }}
            margin="normal"
          />
        );

      case "file":
        return (
          <TextField
            key={field.id}
            id={fieldId}
            type="file"
            required={isRequired}
            fullWidth
            margin="normal"
          />
        );

      default:
        return (
          <TextField
            key={field.id}
            id={fieldId}
            label={field.label}
            placeholder={field.placeholder}
            required={isRequired}
            fullWidth
            variant="outlined"
            margin="normal"
          />
        );
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Form Preview
        <Button
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <Close />
        </Button>
      </DialogTitle>
      <DialogContent dividers style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <h2>{form?.title || "Untitled Form"}</h2>
        {form?.description && <p>{form.description}</p>}

        <form onSubmit={handleSubmit}>
          {form?.fields && form.fields.length > 0 ? (
            form.fields
              .sort((a, b) => a.order - b.order)
              .map((field) => <div key={field.id}>{renderField(field)}</div>)
          ) : (
            <p>No fields added to this form yet.</p>
          )}
          {form?.fields && form.fields.length > 0 && (
            <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
              <Button type="reset" variant="outlined">
                Reset
              </Button>
            </div>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <Info fontSize="small" style={{ marginRight: 4 }} />
          <span style={{ fontSize: "0.9rem" }}>
            Form data will be stored in MongoDB collection:
            <code style={{ marginLeft: 4, background: "#eee", padding: "0 4px" }}>
              form_responses
            </code>
          </span>
        </div>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
        <Button
          variant="contained"
          color="success"
          startIcon={<RocketLaunch />}
          onClick={handlePublish}
        >
          Publish Form
        </Button>
      </DialogActions>
    </Dialog>
  );
}
